import { howItWorks } from '@/mocks/categories';

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 rounded-full text-xs font-medium mb-4">
            Getting Started
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            How Superbuy Sheet Works
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Four simple steps to transform your shopping experience with organized product information.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {howItWorks.map((step) => (
            <div key={step.step} className="relative group">
              <div className="flex flex-col items-center text-center p-6 bg-background-50 rounded-2xl border border-background-200/60 h-full">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-5 group-hover:bg-secondary-500 group-hover:text-background-50 transition-all relative">
                  <i className={`${step.icon} text-xl`}></i>
                  <span className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs font-bold">
                    {step.step}
                  </span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}